import React from 'react';

import { RegistrosProvider } from "./registros";
import { FolhaColheitaProvider } from './folhaColheita';
import { FolhaMensalistaProvider } from './folhaMensalista';
import { VendasProvider } from './vendas';
import { ComprasProvider } from './compras';
import RastreabilidadeProvider from "./rastreabilidade/index";

function ControleProvider({ children }) {
  return <RegistrosProvider>
    <FolhaColheitaProvider>
      <FolhaMensalistaProvider>
        <VendasProvider>
          <ComprasProvider>
            <RastreabilidadeProvider>{children}</RastreabilidadeProvider>
          </ComprasProvider>
        </VendasProvider>
      </FolhaMensalistaProvider>
    </FolhaColheitaProvider>
  </RegistrosProvider>
}

export { ControleProvider };
